'use client';

import { c as _c } from "react/compiler-runtime";
import * as Sentry from '@sentry/nextjs';
import type { ErrorBoundaryProps } from './types';
export function ErrorBoundary(t0) {
  const $ = _c(10);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      tags: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const tags = t2;
  let t3;
  if ($[5] !== tags) {
    t3 = scope => {
      Object.entries(tags).forEach(t4 => {
        const [key, value] = t4;
        scope.setTag(key, value);
      });
    };
    $[5] = tags;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <Sentry.ErrorBoundary beforeCapture={t3} {...props} />;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}